import styled from 'styled-components';
import SearchResultItem from "./Item";
import "./List.scss";

const Default = styled.div`
  &&& {
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    max-width: inherit;
  }
`;

const Grid = styled.div`
  &&& {
    display: grid;
    grid-template-columns: repeat(${(props) => props.countDesktop}, 1fr);
    grid-gap: ${(props) => props.gapDesktop};

    @media screen and (max-width: 600px) {
      grid-template-columns: repeat(${(props) => props.countMobile}, 1fr);
      grid-gap: ${(props) => props.gapMobile};
    }
  }
`;

function SearchResultsList({ articles = [], options, handleClickItem }) {
  return (
    <Default className="beon-showcase--grid beon-showcase--default" >
      {articles && (
        <Grid 
          className="beon-showcase__items-wrapper" 
          {...options.customOptions}
        >
          {articles.map((item, i) => <SearchResultItem key={item._id || i} item={item} handleClickItem={handleClickItem} /> )}
        </Grid>
      )}
    </Default>
  );
}

export default SearchResultsList;
